<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre1 calibre1" id="untitled-1">
<p class="normal-229-0-override3"><span class="no-style-override2">For the Victims</span></p>
<p class="normal-229-0-override3"><span class="no-style-override2">Both the Living and the Dead</span></p>
<p class="calibre2" id="calibre_pb_10"></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?29159e46